import { useEffect, useState } from "react";

export const MotivosSelect = ({
  name,
  value,
  onChange,
  tipo = "S", // Nuevo prop: "S" = Servicio, "C" = Cotizaciones
}) => {
  const [options, setOptions] = useState([]);
  const [state, setState] = useState([]);
  useEffect(() => {
    if (tipo === "S") {
      setOptions([
        { value: "CC", label: "Consolidado" },
        { value: "PS", label: "Precio del servicio" },
        { value: "DC", label: "Disponibilidad de crédito" },
        { value: "AB", label: "Atención brindada" },
        { value: "NN", label: "No se necesitó" }
      ]);
    } else if (tipo === "C") {
      setOptions([
        { value: "CC", label: "Consolidado" },
        { value: "TE", label: "Tiempo de entrega" },
        { value: "PR", label: "Precio de refacción" },
        { value: "AB", label: "Atención brindada" },
        { value: "NN", label: "No se necesitó" },
      ]);
    }
  }, [tipo]);
  return (
    <select
      className="select-motivos"
      name={name}
      value={value}
      onChange={onChange}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};
